"use strict";

module.exports = {
  CMD: Symbol("cmd"),
  OPTIONS: Symbol("options"),
  TARGET: Symbol("target")
};
